module.exports = __webpack_public_path__ + "static/img/pic-cha.34202c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mainindex/pic-cha.png
// module id = 984
// module chunks = 0